import { ColumnLabel } from '../../../shared/models/ColumnLabel';
import { Link, useNavigation } from 'react-router';
import Spinner from '@rio-cloud/rio-uikit/components/spinner/Spinner';
import { createSearchParams } from '../../../shared/utils/utilsStrings';
import { IFinancialHealth } from '../models/IFinancialHealth';
import { IExtractQueryParams } from '../../../shared/models/IExtractQueryParams';

type TableRowContentProps = {
  row: IFinancialHealth;
  index: number;
  columns: string[];
  columnLabels: ColumnLabel;
  currentExtractLinkIndex: any;
  setCurrentExtractLinkIndex: any;
  queryParams: IExtractQueryParams
};

const TableRowContent = (props: TableRowContentProps) => {
  const { row, index, columns, columnLabels, currentExtractLinkIndex, setCurrentExtractLinkIndex, queryParams} = props;
  const navigation = useNavigation();

  return (
    <tr className='compactRow'>
      {columns.map(col => {
        if ('extractLink' == col) {
          return (
            <td key={col} data-field={columnLabels[col]} >
              <span className='display-flex align-items-center gap-10' >
                {(navigation.state === 'loading' && currentExtractLinkIndex === index) && (
                  <div>
                    <Spinner />
                  </div>
                )}
                <Link
                  to={{ search: createSearchParams({ asset_id: queryParams.assetId, month: queryParams.month.toString(), year: queryParams.year.toString() }) }}
                  onClick={() => {
                    setCurrentExtractLinkIndex(index);
                  }}>Acessar Extrato
                </Link>
              </span>
            </td>
          )
        }

        if(['activeMaintenanceContract'].includes(col)){
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <div
                  style={{ minWidth: 90, textTransform: 'capitalize' }}
                  className={row[col as keyof IFinancialHealth] == 150 ? 'label label-warning' : 'label label-danger'}
              >
                {row.activeMaintenanceContract}
                {row.activeMaintenanceContract > 1 ? ' Pontos' : ' Ponto'}
              </div>
            </td>
          );
        }

        if(['responsibleMaintenance'].includes(col)){
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <div
                  style={{ minWidth: 90, textTransform: 'capitalize' }}
                  className={row.responsibleMaintenance < 100 ? 'label label-danger' : 'label label-success'}
              >
                {row.responsibleMaintenance}
                {row.responsibleMaintenance > 1 ? ' Pontos' : ' Ponto'}
              </div>
            </td>
          );
        }

        if(['brandLoyalty'].includes(col)){
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <div
                  style={{ minWidth: 90, textTransform: 'capitalize' }}
                  className={row[col as keyof IFinancialHealth] == 0 ? 'label label-muted' : 'label label-success'}
              >
                {row[col as keyof IFinancialHealth]}
                {row.brandLoyalty > 1 ? ' Pontos' : ' Ponto'}
              </div>
            </td>
          );
        }

        if(['paymentOnDay'].includes(col)){
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <div
                  style={{ minWidth: 90, textTransform: 'capitalize' }}
                  className={row.paymentOnDay < 0 ? 'label label-danger' : 'label label-success'}
              >
                {row.paymentOnDay < 0 ? `${row[col as keyof IFinancialHealth]} Pontos` : 'OK'}
              </div>
            </td>
          );
        }

        return (
          <td key={col} className='text-size-14' data-field={columnLabels[col]}>
            <span>{row[col as keyof IFinancialHealth]}</span>
          </td>
        );
      })}
    </tr>
  );
};

export default TableRowContent;